import { useLoaderDataInternal } from './UsersConfig.loader'

// TODO: use router id everywhere
export const ROUTER_ID = 'groupConfig'
export function loader() {
  // use loader of UserConfig
  throw new Error('not implemented')
}
export function useLoaderData() {
  return useLoaderDataInternal(ROUTER_ID)
}
